<template>
	<div>
		<h6 class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md" style="width:fit-content">
			{{ $t('promotion.branchList') }}
		</h6>
		<div class="ts-pl-4">
			<ts-checkbox
				v-for="(b, index) in branches"
				:key="index"
				v-model="model.branch_id_list"
				:value="b.branch_id"
			>{{ b.branch_name_en }}</ts-checkbox>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'branchList',
	props: ['value'],
	data(){
		return {
			model: {}
		}
	},
	created(){
		this.model = this.value
	},
	computed: {
		...mapState('promotion/resource', ['branches'])
	}
}
</script>